import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Structure from './components/Structure';
import Guarantee from './components/Guarantee';
import Pricing from './components/Pricing';
import Circles from './components/Circles';
import TargetAudience from './components/TargetAudience';
import Process from './components/Process';
import CaseStudies from './components/CaseStudies';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-brand-black relative text-brand-text">
      <Navbar />
      <Hero />
      <hr className="border-t border-brand-border m-0" />
      <About />
      <hr className="border-t border-brand-border m-0" />
      <Structure />
      <hr className="border-t border-brand-border m-0" />
      <Guarantee />
      <hr className="border-t border-brand-border m-0" />
      <Pricing />
      <hr className="border-t border-brand-border m-0" />
      <Circles />
      <hr className="border-t border-brand-border m-0" />
      <TargetAudience />
      <hr className="border-t border-brand-border m-0" />
      <Process />
      <hr className="border-t border-brand-border m-0" />
      <CaseStudies />
      <hr className="border-t border-brand-border m-0" />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;